import React from "react";
import "../../../css/Turismo/turismo.css";

const eventos = [
  {
    img: require("../../img/ng-2.jpeg"),
    date: "Año 2024",
    title: "Fiesta Nacional de la Navidad Gaucha",
    link: "/turismo/eventos-anuales/navidad-gaucha",
  },
  {
    img: require("../../img/maraton-2.jpeg"),
    date: "Año 2025",
    title: "Maratón Heroes de Malvinas",
    link: "/turismo/eventos-anuales/maraton",
  },
  {
    img: require("../../img/colectividades-2.jpeg"),
    date: "Año 2025",
    title: "Fiesta Anual de Colectividades",
    link: "/turismo/eventos-anuales/fiesta-anual-de-colectividades",
  },
  {
    img: require("../../img/fiesta-patronales-2.jpeg"),
    date: "Año 2025",
    title: "Fiesta Patronal",
    link: "/turismo/eventos-anuales/fiesta-patronal",
  },
];

const EventosAnuales = () => (
  <section className="eventos-anuales" id="eventos-anuales">
    <h3><strong>Eventos</strong> anuales en nuestra ciudad</h3>
    <div className="row" style={{ width: "98%", marginLeft: "20px" }}>
      {eventos.map((evento, idx) => (
        <div className="col-12 col-md-3" key={idx}>
          <div className="card">
            <div className="image-container">
              <img src={evento.img} alt={evento.title} />
            </div>
            <div className="text-container">
              <p className="date">{evento.date}</p>
              <h2>{evento.title}</h2>
              <a className="btn btn-turismo" href={evento.link}>Ver más fotos</a>
            </div>
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default EventosAnuales;